import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { checkValidity } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Components
import PhotoUpload from '../Modules/PhotoUpload';

const ProfilePhoto = observer(class ProfilePhoto extends React.Component {
  constructor() {
    super();
    this.handlePhotoSubmit = this.handlePhotoSubmit.bind(this);
  }

  componentWillMount() {
    this.state = {
      attachment: []
    }
  }

  handlePhotoSubmit() {
    // const { translation } = this.props;

    if(this.state.attachment.length > 0) {
      const data = {
        image:  this.state.attachment[0]
      }

      this.props.store.SettingsStore.updateProfilePhoto(data, this.props.nextStep);
    } else {
      // const content = {
      //   heading: translation.no_photo.heading,
      //   body: translation.no_photo.body,
      //   button: translation.no_photo.button
      // }
      //
      // this.props.store.SessionStore.showDialog(content);

      this.props.nextStep();
    }
  }

  render() {
    const { translation } = this.props;

    return(
      <form className="panel" onSubmit={(e) => checkValidity(e, this.handlePhotoSubmit)} noValidate>
        <div className="panel__header">
          <h3 className="panel__title"><legend>{translation.heading}</legend></h3>
        </div>

        <div className="panel__body">
          <PhotoUpload
            {...this.props}
            attachment={this.state.attachment}
            parent={this}
          />

          <div className="panel__actions actions">
            <button
              className="actions__btn actions__btn--secondary"
              onClick={this.props.prevStep}
              type="button"
            >
              {translation.back}
            </button>

            <button
              className="actions__btn actions__btn--primary"
              type="submit"
            >
              {translation.button}
            </button>
          </div>
        </div>
      </form>
    )
  }
})

export default translate('ProfilePhoto')(ProfilePhoto);



// WEBPACK FOOTER //
// ./src/app/components/Register/ProfilePhoto.js